import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import { jwtDecode } from 'jwt-decode';
import './Profile.css';

const Profile = () => {
   const navigate = useNavigate();
   const [isLoggedIn, setIsLoggedIn] = useState(false);
   const [userProfile, setUserProfile] = useState(null);
   const [showProfileMenu, setShowProfileMenu] = useState(false);
   const [userType, setUserType] = useState('customer'); // 'customer' or 'business'

   useEffect(() => {
      // Check if user is logged in
      const token = Cookies.get('jwt');
      setIsLoggedIn(!!token);

      if (token) {
         try {
            // Decode JWT to get user info
            const payload = jwtDecode(token);
            setUserProfile({
               name: payload.email.split('@')[0],
               email: payload.email,
               picture: 'https://via.placeholder.com/40x40',
               userType: payload.userType || 'customer'
            });
            setUserType(payload.userType || 'customer');
         } catch (error) {
            console.error('Error decoding token:', error);
            // Fallback to default profile
            setUserProfile({
               name: 'User',
               email: 'user@example.com',
               picture: 'https://via.placeholder.com/40x40',
               userType: 'customer'
            });
         }
      }
   }, []);

   const handleLogin = (type) => {
      setUserType(type);

      // Redirect to Google OAuth with user type
      let baseUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:5000';
      baseUrl = baseUrl.replace(/\/$/, ''); // Remove trailing slash
      baseUrl = baseUrl.replace(/\/api$/, ''); // Remove trailing /api if present

      window.location.href = `${baseUrl}/api/auth/google?userType=${type}`;
   };

   const handleLogout = () => {
      // Remove JWT cookie
      Cookies.remove('jwt');
      setIsLoggedIn(false);
      setUserProfile(null);
      setShowProfileMenu(false);
      // Redirect to home page
      window.location.href = '/';
   };

   const handleDashboardNavigation = () => {
      // For now, both business and customer users go to the same dashboard
      navigate('/my-websites');
      setShowProfileMenu(false);
   };

   return (
      <div className="profile-container">
         {isLoggedIn && userProfile ? (
            <div className="profile-icon-container" onClick={() => setShowProfileMenu(!showProfileMenu)}>
               <img
                  src={userProfile.picture}
                  alt="Profile"
                  className="profile-icon"
               />
            </div>
         ) : (
            <div className="profile-icon-container" onClick={() => setShowProfileMenu(!showProfileMenu)}>
               <i className="fas fa-user profile-icon-placeholder"></i>
            </div>
         )}

         {showProfileMenu && (
            <div className="profile-menu">
               {isLoggedIn && userProfile ? (
                  <>
                     <div className="profile-header">
                        <img
                           src={userProfile.picture}
                           alt="Profile"
                           className="profile-large-icon"
                        />
                        <div className="profile-info">
                           <h3>{userProfile.name}</h3>
                           <p>{userProfile.email}</p>
                           <span className={`user-type-badge ${userProfile.userType}`}>
                              {userProfile.userType === 'business' ? 'Business Owner' : 'Customer'}
                           </span>
                        </div>
                     </div>
                     <div className="profile-menu-items">
                        <button className="menu-item" onClick={() => navigate('/dashboard')}>
                           <i className="fas fa-tachometer-alt"></i>
                           Dashboard
                        </button>

                        {userProfile.userType === 'customer' && (
                           <>
                              <div className="menu-item" style={{ cursor: 'default', justifyContent: 'space-between' }}>
                                 <span><i className="fas fa-wallet"></i> Wallet</span>
                                 <span style={{ fontWeight: 'bold', color: '#10b981' }}>₹1,250</span>
                              </div>
                              <div className="menu-item" style={{ cursor: 'default', justifyContent: 'space-between' }}>
                                 <span><i className="fas fa-star"></i> Points</span>
                                 <span style={{ fontWeight: 'bold', color: '#f59e0b' }}>450</span>
                              </div>
                              <button className="menu-item">
                                 <i className="fas fa-history"></i> Transactions
                              </button>
                           </>
                        )}

                        {userProfile.userType === 'business' && (
                           <button className="menu-item">
                              <i className="fas fa-cog"></i>
                              Settings
                           </button>
                        )}

                        <button className="menu-item" onClick={handleLogout}>
                           <i className="fas fa-sign-out-alt"></i>
                           Logout
                        </button>
                     </div>
                  </>
               ) : (
                  <div className="login-options">
                     <h3>Welcome</h3>
                     <p className="login-description">
                        Choose your account type to continue
                     </p>
                     <button
                        className="login-button business-login"
                        onClick={() => handleLogin('business')}
                     >
                        <i className="fas fa-building"></i>
                        Business Owner
                     </button>
                     <button
                        className="login-button customer-login"
                        onClick={() => handleLogin('customer')}
                     >
                        <i className="fas fa-user"></i>
                        Customer
                     </button>
                     <p className="login-footer">
                        Login with your Google account
                     </p>
                  </div>
               )}
            </div>
         )}

         {showProfileMenu && (
            <div
               className="profile-menu-backdrop"
               onClick={() => setShowProfileMenu(false)}
            ></div>
         )}
      </div>
   );
};

export default Profile;